const FLOW_OUTCOMES = {
    SUPPORT: 'support',
    BOOK_A_MEETING: 'book_a_meeting',
    MULTIPLE_CONTACT_OPTIONS: 'multiple_contact_options',
    SDR_HANDOFF: 'sdr_handoff'
};
const CLIENT_STORAGE_KEYS = {
    CHILIPIPER_URL: 'chilipiperUrl',
    CHILIPIPER_TIMEOUT: 'chilipiperTimeout',
    CHILIPIPER_LINK_TIMESTAMP: 'chilipiperLinkTimestamp',
    USER_FIRST_NAME: 'userFirstName',
    AMANDA_CALL_LINK: 'amandaCallLink',
    AMANDA_TIMEOUT: 'amandaCallLinkExpirationInMS',
    EMAIL_FOR_HUBSPOT_AMANDA_REQUEST: 'userEmailForAmanda'
};
const SERVER_STORAGE_KEYS = {
    CONTACT_SALES_FIRST_NAME: 'contactSalesFirstName',
    CONTACT_SALES_LAST_NAME: 'contactSalesLastName',
    CONTACT_SALES_EMAIL: 'contactSalesEmail',
    CONTACT_SALES_PHONE: 'contactSalesPhone',
    CONTACT_SALES_COMPANY: 'contactSalesCompany',
    CONTACT_SALES_COMPANY_SIZE: 'contactSalesCompanySize',
    CONTACT_SALES_PRODUCT_QUESTION: 'contactSalesProductQuestion',
    CONTACT_SALES_OPEN_TEXT: 'contactSalesOpenText'
};
const SUPPORT_FIELD_MAPPING = {
    firstName: SERVER_STORAGE_KEYS.CONTACT_SALES_FIRST_NAME,
    lastName: SERVER_STORAGE_KEYS.CONTACT_SALES_LAST_NAME,
    email: SERVER_STORAGE_KEYS.CONTACT_SALES_EMAIL,
    phoneNumber: SERVER_STORAGE_KEYS.CONTACT_SALES_PHONE,
    companyName: SERVER_STORAGE_KEYS.CONTACT_SALES_COMPANY,
    companySize: SERVER_STORAGE_KEYS.CONTACT_SALES_COMPANY_SIZE,
    products: SERVER_STORAGE_KEYS.CONTACT_SALES_PRODUCT_QUESTION,
    prompt: SERVER_STORAGE_KEYS.CONTACT_SALES_OPEN_TEXT
};
const DEFAULT_REDIRECT_PATHS = {
    [FLOW_OUTCOMES.SUPPORT]: '/lp/quick-assistance',
    [FLOW_OUTCOMES.BOOK_A_MEETING]: '/sales/book-a-meeting',
    [FLOW_OUTCOMES.MULTIPLE_CONTACT_OPTIONS]: '/sales/contact-options',
    [FLOW_OUTCOMES.SDR_HANDOFF]: '/contact-sales-thank-you'
};
module.exports = {
    FLOW_OUTCOMES,
    CLIENT_STORAGE_KEYS,
    SERVER_STORAGE_KEYS,
    DEFAULT_REDIRECT_PATHS,
    SUPPORT_FIELD_MAPPING
};
